import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ChevronLeft16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.46966 2.46967L10.5303 3.53033L6.06065 8L10.5303 12.4697L9.46966 13.5303L3.93933 8L9.46966 2.46967Z'
      fill='currentColor'
    />
  </Svg>
);

ChevronLeft16.displayName = 'ChevronLeft16';
export default ChevronLeft16;
